"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _InformationTag = _interopRequireDefault(require("../InformationTag/InformationTag"));
var _i18n = require("../../../../Framework/i18n");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _span, _listItemPrimary;
  return {
    MuiListRoot: {
      paddingTop: 0,
      paddingRight: 0,
      paddingLeft: 0
    },
    MuiCheckboxRoot: _defineProperty({
      //margin: '0 0 0 12px',
      padding: 0
    }, theme.breakpoints.down('xs'), {
      margin: '0'
    }),
    MuiTypographyRoot: {
      lineHeight: 1.8
    },
    MuiTypographyNoWrap: {
      whiteSpace: 'nowrap',
      minWidth: 50,
      fontSize: 15,
      padding: '0 16px'
    },
    gutterBottom: {
      marginBottom: 0
    },
    itemTitle: {
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    listItemPrimary: (_listItemPrimary = {
      padding: '0 2px'
    }, _defineProperty(_listItemPrimary, theme.breakpoints.down('xs'), {
      padding: 0
    }), _defineProperty(_listItemPrimary, '& span', (_span = {
      fontSize: 15,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: '160px',
      display: 'block'
    }, _defineProperty(_span, theme.breakpoints.down('md'), {
      minWidth: 140
    }), _defineProperty(_span, theme.breakpoints.down('xs'), {
      minWidth: 50
    }), _span)), _listItemPrimary),
    selectableLabel: _defineProperty({
      padding: '0 10px'
    }, theme.breakpoints.down('xs'), {
      padding: 0
    }),
    infoBtn: _defineProperty({
      flex: '100%'
    }, theme.breakpoints.down('xs'), {
      flex: 0,
      justifyContent: 'flex-end',
      display: 'flex'
    }),
    container: {
      marginBottom: 'auto'
    }
  };
};
var PriceList = /*#__PURE__*/function (_React$Component) {
  _inherits(PriceList, _React$Component);
  var _super = _createSuper(PriceList);
  function PriceList(props) {
    var _this;
    _classCallCheck(this, PriceList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (element) {
      return function () {
        if ((0, _isFunction["default"])(_this.props.onSelectableChanged)) {
          _this.props.onSelectableChanged(element.key, !element.selected);
        }
      };
    });
    return _this;
  }
  _createClass(PriceList, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        list = _this$props.list,
        productTitle = _this$props.productTitle,
        classes = _this$props.classes,
        amount = _this$props.amount,
        hidePrices = _this$props.hidePrices;
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2,
        classes: {
          root: classes.container
        }
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, amount > 0 && list && list.length <= 0 && /*#__PURE__*/_react["default"].createElement(_List["default"], {
        dense: false
      }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
        classes: {
          root: classes.MuiListRoot
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body2",
        gutterBottom: true,
        classes: {
          root: classes.MuiTypographyNoWrap,
          gutterBottom: classes.gutterBottom
        }
      }, amount, " ", (0, _i18n.t)('amountPrice.pieces')), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
        className: classes.listItemPrimary,
        primary: productTitle
      }))), list && list.length > 0 && /*#__PURE__*/_react["default"].createElement(_List["default"], {
        dense: false
      }, list.map(function (element) {
        return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          key: element.key,
          classes: {
            root: classes.MuiListRoot
          }
        }, element.selectable && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: element.selected,
          color: "primary",
          tabIndex: -1,
          disableRipple: true,
          onChange: _this2.handleToggle(element),
          classes: {
            root: classes.MuiCheckboxRoot
          }
        }), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          className: (0, _clsx["default"])(list[0].key === element.key && classes.itemTitle, list[0].key !== element.key && classes.listItemPrimary, element.selectable && classes.selectableLabel),
          primary: element.label
        }), element.key === 'setup_cost' && (0, _i18n.translationExists)('setUpCostInformation') && /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.infoBtn
        }, /*#__PURE__*/_react["default"].createElement(_InformationTag["default"], {
          infoText: (0, _i18n.t)('setUpCostInformation')
        })), element.key === 'production_cost' && (0, _i18n.translationExists)('productionCostInformation') && /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.infoBtn
        }, /*#__PURE__*/_react["default"].createElement(_InformationTag["default"], {
          infoText: (0, _i18n.t)('productionCostInformation')
        })), !hidePrices && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body2",
          gutterBottom: true,
          align: "right",
          classes: {
            root: classes.MuiTypographyNoWrap,
            gutterBottom: classes.gutterBottom
          }
        }, element.selectable && !element.selected ? '' : element.price));
      }))));
    }
  }]);
  return PriceList;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'PriceList'
})(PriceList);